import { useNavigate } from "react-router-dom";

// Clickable director/actor names; safe inside card <Link>s (no nested anchors).
export const PersonLinks = ({ names = [], kind = "director", className = "", prefix = "Directed by ", max = 2, testid }) => {
  const navigate = useNavigate();
  const list = (names || []).filter(Boolean).slice(0, max);
  if (!list.length) return null;
  const go = (e, n) => { e.preventDefault(); e.stopPropagation(); navigate(`/${kind}/${encodeURIComponent(n)}`); };
  return (
    <p className={className} data-testid={testid || `${kind}-links`}>
      <span className="text-white/45">{prefix}</span>
      {list.map((n, i) => (
        <span key={n}>
          {i > 0 && ", "}
          <span
            role="link"
            tabIndex={0}
            data-testid={`${kind}-link-${n.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={(e) => go(e, n)}
            onKeyDown={(e) => { if (e.key === "Enter") go(e, n); }}
            className="cursor-pointer underline decoration-amber/40 underline-offset-2 transition-colors duration-200 hover:text-amber hover:decoration-amber"
          >
            {n}
          </span>
        </span>
      ))}
    </p>
  );
};

export const DirectorLinks = (props) => <PersonLinks kind="director" {...props} />;
export const ActorLinks = (props) => <PersonLinks kind="actor" prefix="Starring " max={3} {...props} />;
